/*****************************************************************************
 * 사투리 메뉴 컴포넌트
 *
 * CopyRight (C) 2023 박주형
 *****************************************************************************/
import {Component, HostBinding, OnInit} from '@angular/core';
import {Router} from "@angular/router";

import {REGION_INFO2_LIST, REGION_INFO2_MAP, REGION_LIST} from "../../shared/defines/desktop.const";
import {CITY2, CITY2_DEFAULT, GetRegionName, isCity2, REGION, REGION2} from "../../shared/defines/gukeo.const";
import {LIST_TYPE, SearchParam} from "../../shared/defines/client.const";
import {VideoStory} from "../../shared/models/video.model";
import {makeImageUrl} from "../../shared/defines/client.func";
import {VideoService} from "../../shared/services/video/video.service";
import {GlobalEventService} from "../../shared/services/global-event/global-event.service";


@Component({
  selector: 'app-dialect-menu',
  templateUrl: './dialect-menu.component.html',
  styleUrls: ['./dialect-menu.component.scss']
})
export class DialectMenuComponent implements OnInit {
  @HostBinding('class') class = 'all-menu-group-list';
  @HostBinding('style.display') styleBlock = 'block';

  protected readonly makeImageUrl = makeImageUrl;
  protected readonly REGION_INFO2_LIST = REGION_INFO2_LIST;


  protected listStory: VideoStory[] | null = null;

  constructor(
    private router: Router,
    private videoSvc: VideoService,
    private globalEventSvc: GlobalEventService,
  ) {

  }

  ngOnInit() {
    console.log('DialectMenuComponent.ngOnInit()');

    this.videoSvc.GetStoryList().subscribe((listStory: VideoStory[]) => {
      this.listStory = listStory;
    });
  }

  protected onChangeCity(city2: CITY2) {
    console.log('DialectMenuComponent.onChangeRegion()', city2);

    if (city2 === CITY2_DEFAULT) {
      this.router.navigate(['/dialect', 'region']).then();
    }
    else {
      if (!isCity2(city2)) {
        throw new Error('DialectMenuComponent.onChangeRegion() invalid city = ' + city2);
      }

      const queryParams: SearchParam = {
        city: city2,
      };
      this.router.navigate(['/dialect', 'region'], { queryParams }).then();
    }
  }

  protected onSelectStory($event: MouseEvent, story: VideoStory): void {
    console.log('DialectMenuComponent.onSelectStory()', $event);
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    const queryParams: SearchParam = {
      story: story.no,
    };
    this.router.navigate(['/dialect', 'story'], { queryParams }).then();
  }

  protected onGotoDialistList($event: MouseEvent, region2: REGION2): void {
    console.log('DialectMenuComponent.onGotoDialistList()', $event);
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    const regionText = REGION_INFO2_MAP.get(region2)?.region2 ?? CITY2_DEFAULT;
    if (regionText) {
      const queryParams: SearchParam = {
        ...(region2 !== '전국' ? {region2: regionText} : {}),
      };

      this.router.navigate(['/dialect-list', LIST_TYPE.SERVER], {queryParams}).then();
    }
    else {
      console.error('DialectMenuComponent::onGotoDialistList() invalid region2 =', region2);
    }
  }
}
